/**
 * @namespace Browser and other environment detection.
 */
Foundation.Environment = window["Foundation"]["Environment"] = {};


/**
 * Determine if a user agent string is from what we consider a mobile device.
 * @param {string} ua
 * @return {boolean}
 */
Foundation.Environment.userAgentStringIsMobile = function (ua) {
    var mobileTestMatch = ua.match(/\b(iPhone|iPod|Android|Pre|BlackBerry|Windows Phone)\b/i);

    if (mobileTestMatch) {
        switch (mobileTestMatch[0].toLowerCase()) {
            case "blackberry":
            case "android":
                // Make sure Android and Blackberry devices identify themselves as a mobile device.
                if (ua.match(/\bMobile\b/i)) return true;
                break;

            case "pre":
                // Be extra cautious that this really is a Palm phone when matching "pre".
                if (ua.match(/\bwebOS\b/i)) return true;
                break;

            default:
                return true;
        }
    }

    return false;
}

/**
 * Detect if this browser is a what we consider to be a mobile device.
 * @return {boolean}
 */
Foundation.Environment.isMobile = function () {
    return Foundation.Environment.userAgentStringIsMobile(navigator.userAgent);
}


/**
 * Determine if a user agent string is from an iPad.
 * @param {string} ua
 * @return {boolean}
 */
Foundation.Environment.userAgentStringIsIpad = function (ua) {
    return !!(ua.match(/\(iPad\b/));
}

/**
 * Detect if this browser is running on an iPad.
 * @return {boolean}
 */
Foundation.Environment.isIpad = function () {
    return Foundation.Environment.userAgentStringIsIpad(navigator.userAgent);
}

// ---------------------------------------------------------------------

window["Foundation"]["Environment"]["isMobile"] = Foundation.Environment.isMobile;
window["Foundation"]["Environment"]["isIpad"] = Foundation.Environment.isIpad;

// Backwards compatibility.
window["Foundation"]["browserIsMobile"] = Foundation.Environment.isMobile;
